export var defaultProps = {
    className: '',
    style: {},
    description: '暂无数据',
    image: '',
};
